import React, { useEffect, useState, useRef } from "react";
import "./CSS/home.css";

import Navbar from "../Components/Navbar";
import BreatheAnimation from "../Components/BreatheAnimation";
import GlobalCursorFollower from "../Components/ScrollDown";
// import AWaves from "../Components/AWaves"; 

import star from "../Images/assets/asset-star.png";
import work1 from "../Images/work1.png";
import work2 from "../Images/work2.png";
import work3 from "../Images/work3.png";
import work4 from "../Images/work4.png";
import work5 from "../Images/work5a.png";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Contact from "../Components/Contact";

function Home() {
  const [text, setText] = useState("");
  const imageRefs = useRef([]);
  const aboutTitleRef = useRef(null);
  const workTitleRef = useRef(null);
  const skillsTitleRef = useRef(null);
  const connectTitleRef = useRef(null);
  const projectCardRefs = useRef([]);
  const skillCategoryRefs = useRef([]);
  const connectPanelRef = useRef(null);

  useEffect(() => {
    const targetText = ".... .- .-. ... .... / -.- .- .-. .- -. .-- .- .-..";
    let currentIndex = 0;

    const intervalId = setInterval(() => {
      setText(targetText.substring(0, currentIndex + 1));
      currentIndex += 1;

      if (currentIndex === targetText.length) {
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const titleRefs = [aboutTitleRef, workTitleRef, skillsTitleRef, connectTitleRef]
        .map((r) => r.current)
        .filter(Boolean);

      titleRefs.forEach((el) => {
        gsap.fromTo(
          el,
          { x: "-10%", opacity: 0 },
          {
            x: "0%",
            opacity: 1,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
            },
          }
        );
      });

      const cards = skillCategoryRefs.current.filter(Boolean);
      if (cards.length) {
        gsap.fromTo(
          cards,
          { y: 30, opacity: 0, rotateX: 8, transformPerspective: 800 },
          {
            y: 0,
            opacity: 1,
            rotateX: 0,
            duration: 0.9,
            ease: "power3.out",
            stagger: 0.08,
            scrollTrigger: {
              trigger: cards[0],
              start: "top 85%",
            },
          }
        );
      }

      const workCards = projectCardRefs.current.filter(Boolean);
      if (workCards.length) {
        gsap.fromTo(
          workCards,
          { y: 30, opacity: 0, rotateX: 8, transformPerspective: 800 },
          {
            y: 0,
            opacity: 1,
            rotateX: 0,
            duration: 0.9,
            ease: "power3.out",
            stagger: 0.1,
            scrollTrigger: {
              trigger: workCards[0],
              start: "top 85%",
            },
          }
        );
      }

      if (connectPanelRef.current) {
        gsap.fromTo(
          connectPanelRef.current,
          { y: 30, opacity: 0, rotateX: 8, transformPerspective: 800 },
          {
            y: 0,
            opacity: 1,
            rotateX: 0,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: {
              trigger: connectPanelRef.current,
              start: "top 85%",
            },
          }
        );
      }
    });

    imageRefs.current.forEach((ref, index) => {
      if (ref) {
        gsap.fromTo(
          ref,
          { y: 0 },
          {
            y: 200 + index * 50,
            ease: "none",
            scrollTrigger: {
              trigger: ref,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            },
          }
        );
      }
    });

    return () => ctx.revert();
  }, []);

  const skills = [
    {
      category: "Programming Languages",
      items: ["C++", "PHP", "TypeScript", "JavaScript (ES6+)", "Go"],
    },
    {
      category: "Frontend Development",
      items: [
        "React.js",
        "Next.js",
        "HTML5",
        "CSS3",
        "Tailwind CSS",
        "Bootstrap",
        "GSAP",
        "Zustand",
        "TanStack Query",
        "Responsive Design",
      ],
    },
    {
      category: "Backend Development",
      items: ["Laravel PHP", "Node.js", "Nginx", "REST API Development", "OpenAPI", "Payment Gateway Integration", "Redis"],
    },
    {
      category: "Databases",
      items: ["PostgreSQL", "Amazon RDS", "Amazon Aurora", "Supabase"],
    },
    {
      category: "Testing & QA",
      items: ["Vitest", "Jest", "PHPUnit", "Pest", "Cypress", "Postman"],
    },
    {
      category: "DevOps & Infrastructure",
      items: ["AWS EC2", "AWS Lambda", "AWS S3", "Vercel", "Digital Ocean", "Docker", "CI/CD (GitHub Actions, GitLab CI)"],
    },
    {
      category: "AI & Automation",
      items: ["Dify", "LangChain", "RAG", "Vector Databases (ChromaDB, Pinecone)", "n8n", "Zapier"],
    },
    {
      category: "Tools & Platforms",
      items: ["GitHub", "GitLab", "Figma", "Chrome DevTools", "Sentry", "Material UI", "shadcn/ui"],
    },
    {
      category: "Languages",
      items: ["English (Fluent)", "Hindi (Native)", "Japanese (Business)"],
    },
  ];

  return (
    <div className="body">
      <div className="globalcursor">
        <GlobalCursorFollower />
      </div>
      <Navbar />
      <div className="body-container">
        <div className="container-0">
          <div className="innner-body">
            Harsh Karanwal<span style={{ color: "#c3ff03" }}>.</span>
          </div>
          <div className="innner-body-sp">
            <p>Harsh</p>
            <p style={{ marginTop: "-10px" }}>Karanwal<span style={{ color: "#c3ff03" }}>.</span></p>
          </div>
          <div className="innner-body2">
            <span className="main-subtitle typing-text">{text}</span>
          </div>
        </div>
        <div className="container-1">
          <div className="container-1-a">
            <div className="keyboard">
              <div className="keyboard-row">
                <span className="key">C</span>
                <span className="key">R</span>
                <span className="key">E</span>
                <span className="key">A</span>
                <span className="key">T</span>
                <span className="key">I</span>
                <span className="key">V</span>
                <span className="key">E</span>
                <img src={star} alt="" />
              </div>
              <div className="keyboard-row">
                <span className="key">D</span>
                <span className="key">E</span>
                <span className="key">V</span>
                <span className="key">E</span>
                <span className="key">L</span>
                <span className="key">O</span>
                <span className="key">P</span>
                <span className="key">E</span>
                <span className="key">R</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-2">
        <div className="container-2-a">
          <div className="container-2-b" ref={aboutTitleRef}>
            <img className="star" src={star} alt="" />
            <h1 id="about">About</h1>
            {/* <h1 class="cursor typewriter-animation">About</h1> */}
          </div>
          <div className="container-2-c">
            <p>
              I collaborate with agencies and designers to craft memorable
              user experiences, bringing their vision to life with a nice
              touch of animation.
            </p>
            <p>
              I started with simple CSS, played with JS and GSAP, followed my
              imagination, did back-end dev from scratch, worked with all
              kinds of CMS, focused on creative dev, worked on 15+ projects
              and 3 team colaborations, won a few hackathons, and keep on
              learning.
            </p>
          </div>
        </div>
        <div className="container-2-e">
          <BreatheAnimation />
        </div>
      </div>
      <div className="container-3">
        <div className="container-2-b" ref={workTitleRef}>
          <img className="star" src={star} alt="" />
          <h1 id="work">Work</h1>
        </div>
        <div className="container-3-a">
          <div
            className="project-card"
            ref={(el) => {
              projectCardRefs.current[0] = el;
            }}
          >
            <div className="project-image-container">
              <a href="https://bloggerblogger.vercel.app/welcome" target="_blank" rel="noopener noreferrer">
                <img src={work4} alt="Blogger Blog Project" />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://bloggerblogger.vercel.app/welcome" target="_blank" rel="noopener noreferrer" className="project-link">
                    <span>Visit</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Blogger</h3>
              <p className="project-description">A modern blogging platform with dynamic content management and user interactions.</p>
              <div className="project-skills">
                <span className="skill-tag">Next.js</span>
                <span className="skill-tag">Supabase</span>
                <span className="skill-tag">Vercel</span>
                <span className="skill-tag">Typescript</span>
                <span className="skill-tag">Tailwind CSS</span>
              </div>
            </div>
          </div>
 
          <div
            className="project-card"
            ref={(el) => {
              projectCardRefs.current[3] = el;
            }}
          >
            <div className="project-image-container">
              <a href="https://cubetimes.app/" target="_blank" rel="noopener noreferrer">
                <img src={work5} alt="Cube Times Project" />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://cubetimes.app/" target="_blank" rel="noopener noreferrer" className="project-link">
                    <span>Visit</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Cube Times</h3>
              <p className="project-description">A Rubik's Cube Timer built with ❤️ for the speedcubing community.
              </p>
              <div className="project-skills">
                <span className="skill-tag">Next.js</span>
                <span className="skill-tag">Next Auth</span>
                <span className="skill-tag">Vercel</span>
                <span className="skill-tag">Zustand</span>
                <span className="skill-tag">AWS RDS</span>
              </div>
            </div>
          </div>

          <div
            className="project-card"
            ref={(el) => {
              projectCardRefs.current[1] = el;
            }}
          >
            <div className="project-image-container">
              <a href="https://www.webscripts.ca/" target="_blank" rel="noopener noreferrer">
                <img src={work3} alt="WebScripts Project" />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://www.webscripts.ca/" target="_blank" rel="noopener noreferrer" className="project-link">
                    <span>Visit</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">WebScripts</h3>
              <p className="project-description">Professional web development services showcasing modern design and functionality.</p>
              <div className="project-skills">
                <span className="skill-tag">Wordpress</span>
                <span className="skill-tag">Elementor</span>
                <span className="skill-tag">JavaScript</span>
                <span className="skill-tag">Yoast seo</span>
              </div>
            </div>
          </div>

          <div
            className="project-card"
            ref={(el) => {
              projectCardRefs.current[2] = el;
            }}
          >
            <div className="project-image-container">
              <a href="https://tscglobaltrading.com/" target="_blank" rel="noopener noreferrer">
                <img src={work1} alt="TSC Global Trading Project" />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://tscglobaltrading.com/" target="_blank" rel="noopener noreferrer" className="project-link">
                    <span>Visit</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">TSC Global Trading</h3>
              <p className="project-description">Corporate website for international trading company with modern business aesthetics.</p>
              <div className="project-skills">
                <span className="skill-tag">React.js</span>
                <span className="skill-tag">Vercel</span>
                <span className="skill-tag">JavaScript</span>
              </div>
            </div>
          </div>

          <div
            className="project-card"
            ref={(el) => {
              projectCardRefs.current[3] = el;
            }}
          >
            <div className="project-image-container">
              <a href="https://www.shreeumiyaenterprise.in/" target="_blank" rel="noopener noreferrer">
                <img src={work2} alt="Shree Umiya Enterprise Project" />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://www.shreeumiyaenterprise.in/" target="_blank" rel="noopener noreferrer" className="project-link">
                    <span>Visit</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Shree Umiya Enterprise</h3>
              <p className="project-description">Enterprise business website with professional design and comprehensive information.</p>
              <div className="project-skills">
                <span className="skill-tag">React.js</span>
                <span className="skill-tag">Supabase</span>
                <span className="skill-tag">Vercel</span>
                <span className="skill-tag">JavaScript</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-skills">
        <div className="container-2-b" ref={skillsTitleRef}>
          <img className="star" src={star} alt="" />
          <h1 id="skills">Skills</h1>
        </div>

        <div className="skills-grid">
          {skills.map((group, idx) => (
            <div
              key={group.category}
              className="skill-category-card"
              ref={(el) => {
                skillCategoryRefs.current[idx] = el;
              }}
            >
              <div className="skill-category-header">
                <h3 className="skill-category-title">{group.category}</h3>
                <span className="skill-category-count">{group.items.length}</span>
              </div>
              <div className="skill-chips">
                {group.items.map((item) => (
                  <span key={`${group.category}-${item}`} className="skill-chip">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container-4">
        <div className="container-2-b" ref={connectTitleRef}>
          <img className="star" src={star} alt="" />
          <h1 id="connect">Connect with me</h1>
        </div>
        <div ref={connectPanelRef}>
          <Contact />
        </div>
      </div>
    </div>
  );
}

export default Home;
